import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { UsersComponent } from "./users.component";

@NgModule({
    declarations: [
      UsersComponent
    ],
    imports: [
      CommonModule,
      RouterModule.forChild([ {
        path: 'users',
        canActivate: [AuthGuardWithForcedLogin],
        data: { expectedPermissions: HSPAPermission.ManageUsers },
        component: UsersComponent,
      },
    ]),
    ReactiveFormsModule
    ],
    providers: [],
    exports: [],
  })
  export class UsersModule { }